/* eslint-disable @typescript-eslint/no-var-requires */
const pic01 = require('@/assets/imgs/rules-res/pic01.jpg')
const bigEyeChart = require('@/assets/imgs/rules-res/big_eye_chart.jpg')
const bigEyeChart02 = require('@/assets/imgs/rules-res/big_eye_chart02.jpg')
const bigEyeChart03 = require('@/assets/imgs/rules-res/big_eye_chart03.jpg')
const bigEyeRedchart01 = require('@/assets/imgs/rules-res/big_eye_redchart01.jpg')
const bigEyeRedchart02 = require('@/assets/imgs/rules-res/big_eye_redchart02.jpg')
const bigEyeRedchart03 = require('@/assets/imgs/rules-res/big_eye_redchart03.jpg')
const smallEyeChart01 = require('@/assets/imgs/rules-res/small_eye_chart01.jpg')
const smallEyeChart02 = require('@/assets/imgs/rules-res/small_eye_chart02.jpg')
const smallEyeChart03 = require('@/assets/imgs/rules-res/small_eye_chart03.jpg')
const smallEyeRedchart01 = require('@/assets/imgs/rules-res/small_eye_redchart01.jpg')
const smallEyeRedchart02 = require('@/assets/imgs/rules-res/small_eye_redchart02.jpg')
const smallEyeRedchart03 = require('@/assets/imgs/rules-res/small_eye_redchart03.jpg')
const cockroachChart01 = require('@/assets/imgs/rules-res/cockroach_chart01.jpg')
const cockroachBluechart01 = require('@/assets/imgs/rules-res/cockroach_bluechart01.jpg')
const cockroachBluechart02 = require('@/assets/imgs/rules-res/cockroach_bluechart02.jpg')
const cockroachRedchart01 = require('@/assets/imgs/rules-res/cockroach_redchart01.jpg')
const cockroachRedchart02 = require('@/assets/imgs/rules-res/cockroach_redchart02.jpg')
const cockroachRedchart03 = require('@/assets/imgs/rules-res/cockroach_redchart03.jpg')
const ask1 = require('@/assets/imgs/rules-res/ask_1.jpg')

type RoadIntroCopy = {
    alt: string
    titleIntro: string
    bodyIntro: string
    titleRecord: string
    bodyRecord: string
    titleBigRoad: string
    bodyBigRoad: string
    titleBigEye: string
    bodyBigEye: string
    asShown: string
    bodyBigEyeCoord: string
    bigEyeBlueTitle: string
    downward: string
    newColumn: string
    bigEyeBlueDown: string
    bigEyeBlueNewCol: string
    bigEyeRedTitle: string
    bigEyeRedDown1: string
    bigEyeRedDown2: string
    bigEyeRedNewCol: string
    titleSmallRoad: string
    bodySmallRoad: string
    bodySmallRoadCoord: string
    smallBlueTitle: string
    smallBlueDown: string
    smallBlueNewCol: string
    smallRedTitle: string
    smallRedDown1: string
    smallRedDown2: string
    smallRedNewCol: string
    titleCockroach: string
    bodyCockroach: string
    bodyCockroachCoord: string
    cockroachBlueTitle: string
    cockroachBlueDown: string
    cockroachBlueNewCol: string
    cockroachRedTitle: string
    cockroachRedDown1: string
    cockroachRedDown2: string
    cockroachRedNewCol: string
    titleAsk: string
    bodyAsk: string
}

const copyCn: RoadIntroCopy = {
    alt: '牌路介绍',
    titleIntro: '牌路介紹:',
    bodyIntro: '「路」的意思，是百家樂開牌的結果記錄。',
    titleRecord: '一、开牌结果的纪录:',
    bodyRecord:
        '红色珠为庄，蓝色珠为闲, 绿色珠为和，红点在珠的左上角代表庄对，蓝点在珠的右下角代表闲对，如果同时出现庄对和闲对，则左珠的上角和右下角标示红点和蓝点。',
    titleBigRoad: '二、大路:',
    bodyBigRoad:
        '红圈为庄，蓝圈为闲, 庄一列, 闲一列, 序排列出, 如果和的话, 会用一条绿色斜线代表，如果之后连续出现和，便用绿色数字代替。',
    titleBigEye: '三、大眼路:',
    bodyBigEye:
        '大眼路是根据大路延伸出来，从大路的第2列第2行开始分析出来，若那位置没有结果，则以大路的第3列第1行开始分析。',
    asShown: '如下图:',
    bodyBigEyeCoord: '先从座标1(第2列第2行)分析，若座标1无庄或闲，则以座标2(第3列第1行)开始分析。',
    bigEyeBlueTitle: '● 大眼路画蓝圈规则:',
    downward: '1. 向下',
    newColumn: '2. 换列',
    bigEyeBlueDown: '以大路最新的结果，水平方式跟前一列作对比，如无结果，则于大眼路画蓝圈。',
    bigEyeBlueNewCol: '以大路最新的结果，如比对前一列与前二列结果位置是不齐整，则于大眼路画蓝圈。',
    bigEyeRedTitle: '● 大眼路写法画红圈规则:',
    bigEyeRedDown1: '以大路最新的结果，水平方式跟前一列作对比，不论结果为庄或闲，则于大眼路画红圈。',
    bigEyeRedDown2: '以大路最新的结果，水平方式跟前一列作对比，如前一列的前二行或以上都无结果，则于大眼路画红圈。',
    bigEyeRedNewCol: '以大路最新的结果，如比对前一列与前二列结果位置是齐整，则于大眼路画红圈。',
    titleSmallRoad: '四、小路:',
    bodySmallRoad:
        '小路是根据大路延伸出来，从大路的第3列第2行开始分析出来，若那位置没有结果，则以大路的第4列第1行开始分析',
    bodySmallRoadCoord: '先从座标1(第3列第2行)分析，若座标1无庄或闲，则以座标2(第4列第1行)开始分析。',
    smallBlueTitle: '● 小路写法画蓝圈规则:',
    smallBlueDown: '以大路最新的结果，水平方式跟前二列作对比，如无结果，则于小眼路画蓝点。',
    smallBlueNewCol: '以大路最新的结果，如比对前一列与前三列结果位置是不齐整，则于小路画蓝点。',
    smallRedTitle: '● 小路写法画红圈规则:',
    smallRedDown1: '以大路最新的结果，水平方式跟前一列作对比，不论结果为庄或闲，则于大眼路画红点。',
    smallRedDown2: '以大路最新的结果，水平方式跟前一列作对比，如前二列的前二行或以上都无结果，则于大眼路画红点。',
    smallRedNewCol: '以大路最新的结果，如比对前一列与前三列结果位置是齐整，则于大眼路画红点。',
    titleCockroach: '五、小强路:',
    bodyCockroach:
        '小路是根据大路延伸出来，从大路的第4列第2行开始分析出来，若那位置没有结果，则以大路的第5列第1行开始分析',
    bodyCockroachCoord: '先从座标1(第4列第2行)分析，若座标1无庄或闲，则以座标2(第5列第1行)开始分析。',
    cockroachBlueTitle: '● 小强路画蓝色斜线规则:',
    cockroachBlueDown: '以大路最新的结果，水平方式跟前三列作对比，如无结果，则于大眼路画蓝色斜线。',
    cockroachBlueNewCol: '以大路最新的结果，如比对前一列与前四列结果位置是不齐整，则于大眼路蓝色斜线。',
    cockroachRedTitle: '● 小强路画红色斜线规则:',
    cockroachRedDown1: '以大路最新的结果，水平方式跟前三列作对比，不论结果为庄或闲，则于大眼路画红色斜线。',
    cockroachRedDown2: '以大路最新的结果，如比对前一列与前四列结果位置是不齐整，则于大眼路蓝色斜线。',
    cockroachRedNewCol: '以大路最新的结果，如比对前一列与前三列结果位置是齐整，则于大眼路画红色斜线。',
    titleAsk: '六、庄问路、闲问路:',
    bodyAsk:
        '此功能是模拟下一局如果开庄或闲时，大路、大眼路、小路、小强路的结果。令玩家更方便及快速地判断该如何投注下一局。'
}

const copyEn: RoadIntroCopy = {
    alt: 'Road introduction',
    titleIntro: 'Road Introduction:',
    bodyIntro: '"Road" means the record of Baccarat dealing results.',
    titleRecord: '1. Recording of dealing results:',
    bodyRecord:
        'Red beads are Banker, blue beads are Player, and green beads are Tie. A red dot in the upper-left of a bead indicates Banker Pair, and a blue dot in the lower-right indicates Player Pair. If both Banker Pair and Player Pair appear, a red dot is marked on the upper-left and a blue dot on the lower-right.',
    titleBigRoad: '2. Big Road:',
    bodyBigRoad:
        'Red circles are Banker and blue circles are Player. Banker occupies one column and Player occupies one column, arranged in sequence. A Tie is shown with a green slash; if Ties continue afterward, they are shown with a green number.',
    titleBigEye: '3. Big Eye Boy:',
    bodyBigEye:
        'Big Eye Boy is derived from the Big Road. Analysis starts from column 2, row 2 of the Big Road. If that position has no result, analysis starts from column 3, row 1 of the Big Road.',
    asShown: 'As shown below:',
    bodyBigEyeCoord:
        'First analyze coordinate 1 (column 2, row 2). If coordinate 1 has no Banker or Player, start analysis from coordinate 2 (column 3, row 1).',
    bigEyeBlueTitle: '● Big Eye Boy blue circle rules:',
    downward: '1. Downward',
    newColumn: '2. New column',
    bigEyeBlueDown:
        'Compare the latest Big Road result horizontally with the previous column. If there is no result, draw a blue circle on Big Eye Boy.',
    bigEyeBlueNewCol:
        'For the latest Big Road result, if the previous column and the column before that are not aligned, draw a blue circle on Big Eye Boy.',
    bigEyeRedTitle: '● Big Eye Boy red circle rules:',
    bigEyeRedDown1:
        'Compare the latest Big Road result horizontally with the previous column. Regardless of whether the result is Banker or Player, draw a red circle on Big Eye Boy.',
    bigEyeRedDown2:
        'Compare the latest Big Road result horizontally with the previous column. If the previous column has no result in the first two rows or more, draw a red circle on Big Eye Boy.',
    bigEyeRedNewCol:
        'For the latest Big Road result, if the previous column and the column before that are aligned, draw a red circle on Big Eye Boy.',
    titleSmallRoad: '4. Small Road:',
    bodySmallRoad:
        'Small Road is derived from the Big Road. Analysis starts from column 3, row 2 of the Big Road. If that position has no result, analysis starts from column 4, row 1 of the Big Road.',
    bodySmallRoadCoord:
        'First analyze coordinate 1 (column 3, row 2). If coordinate 1 has no Banker or Player, start analysis from coordinate 2 (column 4, row 1).',
    smallBlueTitle: '● Small Road blue circle rules:',
    smallBlueDown:
        'Compare the latest Big Road result horizontally with the column two columns prior. If there is no result, draw a blue dot on Small Road.',
    smallBlueNewCol:
        'For the latest Big Road result, if the previous column and the column three columns prior are not aligned, draw a blue dot on Small Road.',
    smallRedTitle: '● Small Road red circle rules:',
    smallRedDown1:
        'Compare the latest Big Road result horizontally with the previous column. Regardless of whether the result is Banker or Player, draw a red dot on Small Road.',
    smallRedDown2:
        'Compare the latest Big Road result horizontally with the previous column. If the column two columns prior has no result in the first two rows or more, draw a red dot on Small Road.',
    smallRedNewCol:
        'For the latest Big Road result, if the previous column and the column three columns prior are aligned, draw a red dot on Small Road.',
    titleCockroach: '5. Cockroach Road:',
    bodyCockroach:
        'Cockroach Road is derived from the Big Road. Analysis starts from column 4, row 2 of the Big Road. If that position has no result, analysis starts from column 5, row 1 of the Big Road.',
    bodyCockroachCoord:
        'First analyze coordinate 1 (column 4, row 2). If coordinate 1 has no Banker or Player, start analysis from coordinate 2 (column 5, row 1).',
    cockroachBlueTitle: '● Cockroach Road blue slash rules:',
    cockroachBlueDown:
        'Compare the latest Big Road result horizontally with the column three columns prior. If there is no result, draw a blue slash on Cockroach Road.',
    cockroachBlueNewCol:
        'For the latest Big Road result, if the previous column and the column four columns prior are not aligned, draw a blue slash on Cockroach Road.',
    cockroachRedTitle: '● Cockroach Road red slash rules:',
    cockroachRedDown1:
        'Compare the latest Big Road result horizontally with the column three columns prior. Regardless of whether the result is Banker or Player, draw a red slash on Cockroach Road.',
    cockroachRedDown2:
        'Compare the latest Big Road result with the previous column and the column four columns prior. If the positions are not aligned, draw a blue slash on Cockroach Road.',
    cockroachRedNewCol:
        'For the latest Big Road result, if the previous column and the column three columns prior are aligned, draw a red slash on Cockroach Road.',
    titleAsk: '6. Banker Ask / Player Ask:',
    bodyAsk:
        'This function simulates the Big Road, Big Eye Boy, Small Road, and Cockroach Road results if the next round is Banker or Player, making it easier and faster for players to decide how to bet on the next round.'
}

const copyKor: RoadIntroCopy = {
    alt: '로드 소개',
    titleIntro: '로드 소개:',
    bodyIntro: '「로드」는 바카라 오픈 결과를 기록한 것을 의미합니다.',
    titleRecord: '1. 오픈 결과 기록:',
    bodyRecord:
        '빨간 구슬은 뱅커, 파란 구슬은 플레이어, 초록 구슬은 타이입니다. 구슬 왼쪽 위의 빨간 점은 뱅커 페어, 오른쪽 아래의 파란 점은 플레이어 페어를 나타냅니다. 뱅커 페어와 플레이어 페어가 동시에 나오면 왼쪽 위와 오른쪽 아래에 빨간 점과 파란 점을 표시합니다.',
    titleBigRoad: '2. 빅 로드:',
    bodyBigRoad:
        '빨간 원은 뱅커, 파란 원은 플레이어이며, 뱅커는 한 열, 플레이어는 한 열로 순서대로 배열됩니다. 타이인 경우 초록 사선으로 표시하고, 이후 타이가 연속되면 초록 숫자로 대체합니다.',
    titleBigEye: '3. 빅 아이 보이:',
    bodyBigEye:
        '빅 아이 보이는 빅 로드에서 파생되며, 빅 로드의 2열 2행부터 분석을 시작합니다. 해당 위치에 결과가 없으면 빅 로드의 3열 1행부터 분석합니다.',
    asShown: '아래 그림과 같습니다:',
    bodyBigEyeCoord:
        '먼저 좌표 1(2열 2행)부터 분석하고, 좌표 1에 뱅커 또는 플레이어가 없으면 좌표 2(3열 1행)부터 분석합니다.',
    bigEyeBlueTitle: '● 빅 아이 보이 파란 원 규칙:',
    downward: '1. 아래로',
    newColumn: '2. 열 변경',
    bigEyeBlueDown:
        '빅 로드의 최신 결과를 이전 열과 수평으로 비교하여 결과가 없으면 빅 아이 보이에 파란 원을 그립니다.',
    bigEyeBlueNewCol:
        '빅 로드의 최신 결과에서 이전 열과 그 앞 열의 결과 위치가 맞지 않으면 빅 아이 보이에 파란 원을 그립니다.',
    bigEyeRedTitle: '● 빅 아이 보이 빨간 원 규칙:',
    bigEyeRedDown1:
        '빅 로드의 최신 결과를 이전 열과 수평으로 비교하여 결과가 뱅커든 플레이어든 빅 아이 보이에 빨간 원을 그립니다.',
    bigEyeRedDown2:
        '빅 로드의 최신 결과를 이전 열과 수평으로 비교하여 이전 열의 앞 두 행 이상에 결과가 없으면 빅 아이 보이에 빨간 원을 그립니다.',
    bigEyeRedNewCol:
        '빅 로드의 최신 결과에서 이전 열과 그 앞 열의 결과 위치가 맞으면 빅 아이 보이에 빨간 원을 그립니다.',
    titleSmallRoad: '4. 스몰 로드:',
    bodySmallRoad:
        '스몰 로드는 빅 로드에서 파생되며, 빅 로드의 3열 2행부터 분석을 시작합니다. 해당 위치에 결과가 없으면 빅 로드의 4열 1행부터 분석합니다.',
    bodySmallRoadCoord:
        '먼저 좌표 1(3열 2행)부터 분석하고, 좌표 1에 뱅커 또는 플레이어가 없으면 좌표 2(4열 1행)부터 분석합니다.',
    smallBlueTitle: '● 스몰 로드 파란 원 규칙:',
    smallBlueDown:
        '빅 로드의 최신 결과를 앞의 두 번째 열과 수평으로 비교하여 결과가 없으면 스몰 로드에 파란 점을 그립니다.',
    smallBlueNewCol:
        '빅 로드의 최신 결과에서 이전 열과 앞의 세 번째 열의 결과 위치가 맞지 않으면 스몰 로드에 파란 점을 그립니다.',
    smallRedTitle: '● 스몰 로드 빨간 원 규칙:',
    smallRedDown1:
        '빅 로드의 최신 결과를 이전 열과 수평으로 비교하여 결과가 뱅커든 플레이어든 스몰 로드에 빨간 점을 그립니다.',
    smallRedDown2:
        '빅 로드의 최신 결과를 이전 열과 수평으로 비교하여 앞의 두 번째 열의 앞 두 행 이상에 결과가 없으면 스몰 로드에 빨간 점을 그립니다.',
    smallRedNewCol:
        '빅 로드의 최신 결과에서 이전 열과 앞의 세 번째 열의 결과 위치가 맞으면 스몰 로드에 빨간 점을 그립니다.',
    titleCockroach: '5. 코크로치 로드:',
    bodyCockroach:
        '코크로치 로드는 빅 로드에서 파생되며, 빅 로드의 4열 2행부터 분석을 시작합니다. 해당 위치에 결과가 없으면 빅 로드의 5열 1행부터 분석합니다.',
    bodyCockroachCoord:
        '먼저 좌표 1(4열 2행)부터 분석하고, 좌표 1에 뱅커 또는 플레이어가 없으면 좌표 2(5열 1행)부터 분석합니다.',
    cockroachBlueTitle: '● 코크로치 로드 파란 사선 규칙:',
    cockroachBlueDown:
        '빅 로드의 최신 결과를 앞의 세 번째 열과 수평으로 비교하여 결과가 없으면 코크로치 로드에 파란 사선을 그립니다.',
    cockroachBlueNewCol:
        '빅 로드의 최신 결과에서 이전 열과 앞의 네 번째 열의 결과 위치가 맞지 않으면 코크로치 로드에 파란 사선을 그립니다.',
    cockroachRedTitle: '● 코크로치 로드 빨간 사선 규칙:',
    cockroachRedDown1:
        '빅 로드의 최신 결과를 앞의 세 번째 열과 수평으로 비교하여 결과가 뱅커든 플레이어든 코크로치 로드에 빨간 사선을 그립니다.',
    cockroachRedDown2:
        '빅 로드의 최신 결과에서 이전 열과 앞의 네 번째 열의 결과 위치가 맞지 않으면 코크로치 로드에 파란 사선을 그립니다.',
    cockroachRedNewCol:
        '빅 로드의 최신 결과에서 이전 열과 앞의 세 번째 열의 결과 위치가 맞으면 코크로치 로드에 빨간 사선을 그립니다.',
    titleAsk: '6. 뱅커 묻기, 플레이어 묻기:',
    bodyAsk:
        '이 기능은 다음 라운드가 뱅커 또는 플레이어로 나올 경우 빅 로드, 빅 아이 보이, 스몰 로드, 코크로치 로드의 결과를 시뮬레이션하여 플레이어가 다음 라운드 베팅을 더 쉽고 빠르게 판단할 수 있게 합니다.'
}

const copyKm: RoadIntroCopy = {
    alt: 'ការណែនាំអំពីផ្លូវ',
    titleIntro: 'ការណែនាំអំពីផ្លូវ:',
    bodyIntro: '«ផ្លូវ» មានន័យថាកំណត់ត្រាលទ្ធផលនៃការបើកបៀបាការ៉ាត់។',
    titleRecord: '១. កំណត់ត្រាលទ្ធផលបើកបៀ:',
    bodyRecord:
        'គ្រាប់ពណ៌ក្រហមគឺ Banker គ្រាប់ពណ៌ខៀវគឺអ្នកលេង ហើយគ្រាប់ពណ៌បៃតងគឺស្មើ។ ចំណុចក្រហមនៅជ្រុងខាងលើឆ្វេងនៃគ្រាប់តំណាងឱ្យគូ Banker ហើយចំណុចខៀវនៅជ្រុងខាងក្រោមស្តាំតំណាងឱ្យគូអ្នកលេង។ ប្រសិនបើគូ Banker និងគូអ្នកលេងចេញក្នុងពេលតែមួយ នឹងមានចំណុចក្រហមនៅជ្រុងខាងលើឆ្វេង និងចំណុចខៀវនៅជ្រុងខាងក្រោមស្តាំ។',
    titleBigRoad: '២. ផ្លូវធំ (Big Road):',
    bodyBigRoad:
        'រង្វង់ក្រហមគឺ Banker រង្វង់ខៀវគឺអ្នកលេង។ Banker មួយជួរឈរ អ្នកលេងមួយជួរឈរ ត្រូវបានរៀបតាមលំដាប់។ ប្រសិនបើស្មើ នឹងប្រើបន្ទាត់ទ្រេតពណ៌បៃតង ហើយប្រសិនបើស្មើបន្តបន្ទាប់ នឹងប្រើលេខពណ៌បៃតងជំនួស។',
    titleBigEye: '៣. ផ្លូវភ្នែកធំ (Big Eye Boy):',
    bodyBigEye:
        'ផ្លូវភ្នែកធំត្រូវបានវិភាគពីផ្លូវធំ ដោយចាប់ផ្តើមពីជួរឈរទី 2 ជួរទី 2 នៃផ្លូវធំ។ ប្រសិនបើទីតាំងនោះគ្មានលទ្ធផល នឹងចាប់ផ្តើមវិភាគពីជួរឈរទី 3 ជួរទី 1 នៃផ្លូវធំ។',
    asShown: 'ដូចរូបខាងក្រោម:',
    bodyBigEyeCoord:
        'វិភាគពីកូអរដោនេ 1 (ជួរឈរទី 2 ជួរទី 2) ជាមុនសិន។ ប្រសិនបើកូអរដោនេ 1 គ្មាន Banker ឬអ្នកលេង នឹងចាប់ផ្តើមវិភាគពីកូអរដោនេ 2 (ជួរឈរទី 3 ជួរទី 1)។',
    bigEyeBlueTitle: '● ច្បាប់គូររង្វង់ខៀវសម្រាប់ផ្លូវភ្នែកធំ:',
    downward: '1. ចុះក្រោម',
    newColumn: '2. ប្តូរជួរឈរ',
    bigEyeBlueDown:
        'ប្រៀបធៀបលទ្ធផលថ្មីបំផុតនៃផ្លូវធំជាមួយជួរឈរមុនតាមផ្ដេក។ ប្រសិនបើគ្មានលទ្ធផល ត្រូវគូររង្វង់ខៀវនៅលើផ្លូវភ្នែកធំ។',
    bigEyeBlueNewCol:
        'សម្រាប់លទ្ធផលថ្មីបំផុតនៃផ្លូវធំ ប្រសិនបើទីតាំងលទ្ធផលនៃជួរឈរមុន និងជួរឈរមុននោះមិនស្មើគ្នា ត្រូវគូររង្វង់ខៀវនៅលើផ្លូវភ្នែកធំ។',
    bigEyeRedTitle: '● ច្បាប់គូររង្វង់ក្រហមសម្រាប់ផ្លូវភ្នែកធំ:',
    bigEyeRedDown1:
        'ប្រៀបធៀបលទ្ធផលថ្មីបំផុតនៃផ្លូវធំជាមួយជួរឈរមុនតាមផ្ដេក។ មិនថាលទ្ធផលជា Banker ឬអ្នកលេងទេ ត្រូវគូររង្វង់ក្រហមនៅលើផ្លូវភ្នែកធំ។',
    bigEyeRedDown2:
        'ប្រៀបធៀបលទ្ធផលថ្មីបំផុតនៃផ្លូវធំជាមួយជួរឈរមុនតាមផ្ដេក។ ប្រសិនបើជួរឈរមុនគ្មានលទ្ធផលនៅពីរជួរដំបូង ឬច្រើនជាងនេះ ត្រូវគូររង្វង់ក្រហមនៅលើផ្លូវភ្នែកធំ។',
    bigEyeRedNewCol:
        'សម្រាប់លទ្ធផលថ្មីបំផុតនៃផ្លូវធំ ប្រសិនបើទីតាំងលទ្ធផលនៃជួរឈរមុន និងជួរឈរមុននោះស្មើគ្នា ត្រូវគូររង្វង់ក្រហមនៅលើផ្លូវភ្នែកធំ។',
    titleSmallRoad: '៤. ផ្លូវតូច (Small Road):',
    bodySmallRoad:
        'ផ្លូវតូចត្រូវបានវិភាគពីផ្លូវធំ ដោយចាប់ផ្តើមពីជួរឈរទី 3 ជួរទី 2 នៃផ្លូវធំ។ ប្រសិនបើទីតាំងនោះគ្មានលទ្ធផល នឹងចាប់ផ្តើមវិភាគពីជួរឈរទី 4 ជួរទី 1 នៃផ្លូវធំ។',
    bodySmallRoadCoord:
        'វិភាគពីកូអរដោនេ 1 (ជួរឈរទី 3 ជួរទី 2) ជាមុនសិន។ ប្រសិនបើកូអរដោនេ 1 គ្មាន Banker ឬអ្នកលេង នឹងចាប់ផ្តើមវិភាគពីកូអរដោនេ 2 (ជួរឈរទី 4 ជួរទី 1)។',
    smallBlueTitle: '● ច្បាប់គូររង្វង់ខៀវសម្រាប់ផ្លូវតូច:',
    smallBlueDown:
        'ប្រៀបធៀបលទ្ធផលថ្មីបំផុតនៃផ្លូវធំជាមួយជួរឈរពីរមុនតាមផ្ដេក។ ប្រសិនបើគ្មានលទ្ធផល ត្រូវគូរចំណុចខៀវនៅលើផ្លូវតូច។',
    smallBlueNewCol:
        'សម្រាប់លទ្ធផលថ្មីបំផុតនៃផ្លូវធំ ប្រសិនបើទីតាំងលទ្ធផលនៃជួរឈរមុន និងជួរឈរបីមុនមិនស្មើគ្នា ត្រូវគូរចំណុចខៀវនៅលើផ្លូវតូច។',
    smallRedTitle: '● ច្បាប់គូររង្វង់ក្រហមសម្រាប់ផ្លូវតូច:',
    smallRedDown1:
        'ប្រៀបធៀបលទ្ធផលថ្មីបំផុតនៃផ្លូវធំជាមួយជួរឈរមុនតាមផ្ដេក។ មិនថាលទ្ធផលជា Banker ឬអ្នកលេងទេ ត្រូវគូរចំណុចក្រហមនៅលើផ្លូវតូច។',
    smallRedDown2:
        'ប្រៀបធៀបលទ្ធផលថ្មីបំផុតនៃផ្លូវធំជាមួយជួរឈរមុនតាមផ្ដេក។ ប្រសិនបើជួរឈរពីរមុនគ្មានលទ្ធផលនៅពីរជួរដំបូង ឬច្រើនជាងនេះ ត្រូវគូរចំណុចក្រហមនៅលើផ្លូវតូច។',
    smallRedNewCol:
        'សម្រាប់លទ្ធផលថ្មីបំផុតនៃផ្លូវធំ ប្រសិនបើទីតាំងលទ្ធផលនៃជួរឈរមុន និងជួរឈរបីមុនស្មើគ្នា ត្រូវគូរចំណុចក្រហមនៅលើផ្លូវតូច។',
    titleCockroach: '៥. ផ្លូវខ្មួល (Cockroach Road):',
    bodyCockroach:
        'ផ្លូវខ្មួលត្រូវបានវិភាគពីផ្លូវធំ ដោយចាប់ផ្តើមពីជួរឈរទី 4 ជួរទី 2 នៃផ្លូវធំ។ ប្រសិនបើទីតាំងនោះគ្មានលទ្ធផល នឹងចាប់ផ្តើមវិភាគពីជួរឈរទី 5 ជួរទី 1 នៃផ្លូវធំ។',
    bodyCockroachCoord:
        'វិភាគពីកូអរដោនេ 1 (ជួរឈរទី 4 ជួរទី 2) ជាមុនសិន។ ប្រសិនបើកូអរដោនេ 1 គ្មាន Banker ឬអ្នកលេង នឹងចាប់ផ្តើមវិភាគពីកូអរដោនេ 2 (ជួរឈរទី 5 ជួរទី 1)។',
    cockroachBlueTitle: '● ច្បាប់គូរបន្ទាត់ទ្រេតខៀវសម្រាប់ផ្លូវខ្មួល:',
    cockroachBlueDown:
        'ប្រៀបធៀបលទ្ធផលថ្មីបំផុតនៃផ្លូវធំជាមួយជួរឈរបីមុនតាមផ្ដេក។ ប្រសិនបើគ្មានលទ្ធផល ត្រូវគូរបន្ទាត់ទ្រេតខៀវនៅលើផ្លូវខ្មួល។',
    cockroachBlueNewCol:
        'សម្រាប់លទ្ធផលថ្មីបំផុតនៃផ្លូវធំ ប្រសិនបើទីតាំងលទ្ធផលនៃជួរឈរមុន និងជួរឈរបួនមុនមិនស្មើគ្នា ត្រូវគូរបន្ទាត់ទ្រេតខៀវនៅលើផ្លូវខ្មួល។',
    cockroachRedTitle: '● ច្បាប់គូរបន្ទាត់ទ្រេតក្រហមសម្រាប់ផ្លូវខ្មួល:',
    cockroachRedDown1:
        'ប្រៀបធៀបលទ្ធផលថ្មីបំផុតនៃផ្លូវធំជាមួយជួរឈរបីមុនតាមផ្ដេក។ មិនថាលទ្ធផលជា Banker ឬអ្នកលេងទេ ត្រូវគូរបន្ទាត់ទ្រេតក្រហមនៅលើផ្លូវខ្មួល។',
    cockroachRedDown2:
        'សម្រាប់លទ្ធផលថ្មីបំផុតនៃផ្លូវធំ ប្រសិនបើទីតាំងលទ្ធផលនៃជួរឈរមុន និងជួរឈរបួនមុនមិនស្មើគ្នា ត្រូវគូរបន្ទាត់ទ្រេតខៀវនៅលើផ្លូវខ្មួល។',
    cockroachRedNewCol:
        'សម្រាប់លទ្ធផលថ្មីបំផុតនៃផ្លូវធំ ប្រសិនបើទីតាំងលទ្ធផលនៃជួរឈរមុន និងជួរឈរបីមុនស្មើគ្នា ត្រូវគូរបន្ទាត់ទ្រេតក្រហមនៅលើផ្លូវខ្មួល។',
    titleAsk: '៦. សួរ Banker / សួរអ្នកលេង:',
    bodyAsk:
        'មុខងារនេះក្លែងធ្វើលទ្ធផលនៃផ្លូវធំ ផ្លូវភ្នែកធំ ផ្លូវតូច និងផ្លូវខ្មួល ប្រសិនបើជុំបន្ទាប់ចេញ Banker ឬអ្នកលេង ដើម្បីឱ្យអ្នកលេងងាយស្រួល និងលឿនក្នុងការសម្រេចចិត្តភ្នាល់ជុំបន្ទាប់។'
}

function buildRoadIntro(t: RoadIntroCopy): string {
    return (
        '<p class="title">' + t.titleIntro + '</p>' +
        '<p>' + t.bodyIntro + '</p>' +
        '<p><img src="' + pic01 + '" alt="' + t.alt + '" class="pic01" /></p>' +
        '<p class="title">' + t.titleRecord + '</p>' +
        '<p>' + t.bodyRecord + '</p>' +
        '<p class="title">' + t.titleBigRoad + '</p>' +
        '<p>' + t.bodyBigRoad + '</p>' +
        '<p class="title">' + t.titleBigEye + '</p>' +
        '<p>' + t.bodyBigEye + '</p>' +
        '<p>' + t.asShown + '</p>' +
        '<p><img src="' + bigEyeChart + '" alt="' + t.alt + '" class="big_eye_chart" /></p>' +
        '<p>' + t.bodyBigEyeCoord + '</p>' +
        '<p><b>' + t.bigEyeBlueTitle + '</b></p>' +
        '<div class="chart_bk">' +
        '<div class="chart01">' +
        '<p>' + t.downward + '</p>' +
        '<p><img src="' + bigEyeChart02 + '" alt="' + t.alt + '" class="big_eye_chart02" /></p>' +
        '<p>' + t.bigEyeBlueDown + '</p>' +
        '</div>' +
        '<div class="chart02">' +
        '<p>' + t.newColumn + '</p>' +
        '<p><img src="' + bigEyeChart03 + '" alt="' + t.alt + '" class="big_eye_chart03" /></p>' +
        '<p>' + t.bigEyeBlueNewCol + '</p>' +
        '</div>' +
        '</div>' +
        '<p><b>' + t.bigEyeRedTitle + '</b></p>' +
        '<div class="chart_bk">' +
        '<div class="chart01">' +
        '<p>' + t.downward + '</p>' +
        '<p><img src="' + bigEyeRedchart01 + '" alt="' + t.alt + '" class="big_eye_redchart01" /></p>' +
        '<p>' + t.bigEyeRedDown1 + '</p>' +
        '</div>' +
        '<div class="chart02">' +
        '<p>&nbsp;</p>' +
        '<p><img src="' + bigEyeRedchart02 + '" alt="' + t.alt + '" class="big_eye_redchart02" /></p>' +
        '<p>' + t.bigEyeRedDown2 + '</p>' +
        '</div>' +
        '<div class="chart02">' +
        '<p>' + t.newColumn + '</p>' +
        '<p><img src="' + bigEyeRedchart03 + '" alt="' + t.alt + '" class="big_eye_redchart03" /></p>' +
        '<p>' + t.bigEyeRedNewCol + '</p>' +
        '</div>' +
        '</div>' +
        '<p class="title">' + t.titleSmallRoad + '</p>' +
        '<p>' + t.bodySmallRoad + '</p>' +
        '<p>' + t.asShown + '</p>' +
        '<p><img src="' + smallEyeChart01 + '" alt="' + t.alt + '" class="small_eye_chart01" /></p>' +
        '<p>' + t.bodySmallRoadCoord + '</p>' +
        '<p><b>' + t.smallBlueTitle + '</b></p>' +
        '<div class="chart_bk">' +
        '<div class="chart01">' +
        '<p>' + t.downward + '</p>' +
        '<p><img src="' + smallEyeChart02 + '" alt="' + t.alt + '" class="small_eye_chart02" /></p>' +
        '<p>' + t.smallBlueDown + '</p>' +
        '</div>' +
        '<div class="chart02">' +
        '<p>' + t.newColumn + '</p>' +
        '<p><img src="' + smallEyeChart03 + '" alt="' + t.alt + '" class="small_eye_chart03" /></p>' +
        '<p>' + t.smallBlueNewCol + '</p>' +
        '</div>' +
        '</div>' +
        '<p><b>' + t.smallRedTitle + '</b></p>' +
        '<div class="chart_bk">' +
        '<div class="chart01">' +
        '<p>' + t.downward + '</p>' +
        '<p><img src="' + smallEyeRedchart01 + '" alt="' + t.alt + '" class="small_eye_redchart01" /></p>' +
        '<p>' + t.smallRedDown1 + '</p>' +
        '</div>' +
        '<div class="chart02">' +
        '<p>&nbsp;</p>' +
        '<p><img src="' + smallEyeRedchart02 + '" alt="' + t.alt + '" class="small_eye_redchart02" /></p>' +
        '<p>' + t.smallRedDown2 + '</p>' +
        '</div>' +
        '<div class="chart02">' +
        '<p>' + t.newColumn + '</p>' +
        '<p><img src="' + smallEyeRedchart03 + '" alt="' + t.alt + '" class="small_eye_redchart03" /></p>' +
        '<p>' + t.smallRedNewCol + '</p>' +
        '</div>' +
        '</div>' +
        '<p class="title">' + t.titleCockroach + '</p>' +
        '<p>' + t.bodyCockroach + '</p>' +
        '<p>' + t.asShown + '</p>' +
        '<p><img src="' + cockroachChart01 + '" alt="' + t.alt + '" class="cockroach_chart01" /></p>' +
        '<p>' + t.bodyCockroachCoord + '</p>' +
        '<p><b>' + t.cockroachBlueTitle + '</b></p>' +
        '<div class="chart_bk">' +
        '<div class="chart01">' +
        '<p>' + t.downward + '</p>' +
        '<p><img src="' + cockroachBluechart01 + '" alt="' + t.alt + '" class="cockroach_bluechart01" /></p>' +
        '<p>' + t.cockroachBlueDown + '</p>' +
        '</div>' +
        '<div class="chart02">' +
        '<p>' + t.newColumn + '</p>' +
        '<p><img src="' + cockroachBluechart02 + '" alt="' + t.alt + '" class="cockroach_bluechart02" /></p>' +
        '<p>' + t.cockroachBlueNewCol + '</p>' +
        '</div>' +
        '</div>' +
        '<p><b>' + t.cockroachRedTitle + '</b></p>' +
        '<div class="chart_bk">' +
        '<div class="chart01">' +
        '<p>' + t.downward + '</p>' +
        '<p><img src="' + cockroachRedchart01 + '" alt="' + t.alt + '" class="cockroach_redchart01" /></p>' +
        '<p>' + t.cockroachRedDown1 + '</p>' +
        '</div>' +
        '<div class="chart02">' +
        '<p>&nbsp;</p>' +
        '<p><img src="' + cockroachRedchart02 + '" alt="' + t.alt + '" class="cockroach_redchart02" /></p>' +
        '<p>' + t.cockroachRedDown2 + '</p>' +
        '</div>' +
        '<div class="chart02">' +
        '<p>' + t.newColumn + '</p>' +
        '<p><img src="' + cockroachRedchart03 + '" alt="' + t.alt + '" class="cockroach_redchart03" /></p>' +
        '<p>' + t.cockroachRedNewCol + '</p>' +
        '</div>' +
        '</div>' +
        '<p class="title">' + t.titleAsk + '</p>' +
        '<p>' + t.bodyAsk + '</p>' +
        '<p>' + t.asShown + '</p>' +
        '<p><img src="' + ask1 + '" alt="' + t.alt + '" class="ask_1" /></p>'
    )
}

export const baccaratRoadIntroCn = buildRoadIntro(copyCn)
export const baccaratRoadIntroEn = buildRoadIntro(copyEn)
export const baccaratRoadIntroKor = buildRoadIntro(copyKor)
export const baccaratRoadIntroKm = buildRoadIntro(copyKm)

export default baccaratRoadIntroCn
